import './Buttons.scss';

import { Login } from "@mui/icons-material";
import { Add } from "@mui/icons-material";
import { FileDownload } from "@mui/icons-material";
import { Update } from "@mui/icons-material";
import { Send } from "@mui/icons-material";
import { Print } from "@mui/icons-material";

export const TextButton = ({Icon, title, onClick, color, active}) => {

    return (
        <button className={`text-button ${active ? "--active" : ""}`} onClick={active ? onClick : null}>
            {Icon && <Icon style={{fontSize: "18px", color: active ? color : ""}}/>}
            {title}
        </button>
    )
}

export const Button = ({
                           Icon,
                           title,
                           onClick,
                           type = "button",
                           color,
                           textColor,
                           disabled
                       }) => {
    return (
        <button
            type={type}
            className="button"
            onClick={onClick}
            disabled={disabled}
            style={{
                backgroundColor: color,
                color: textColor
            }}
        >
            {Icon && <Icon style={{ fontSize: 16 }} />}
            {title}
        </button>
    );
};

export const IconButton = ({Icon, onClick, color}) => {

    return (
        <button className={"icon_button"} onClick={onClick}>
            {Icon && <Icon style={{fontSize: "21px", color: color}}/>}
        </button>
    )
}

// export const ButtonLogin = ({onClick}) => {
//
//     return (
//         <Box className={"button_login"}>
//             <Box className={"button_login_container"}>
//                 <Button
//                     variant="contained"
//                     className={"button_login_container_item"}
//                     type="submit"
//                     onClick={onClick}
//                     sx={{
//                         backgroundColor: "#424242",
//                         color: "#fff",
//                         "&:hover" : {
//                             backgroundColor: "#212121"
//                         }
//                     }}
//                 >
//                     <Box className={"button_login_container_item_icon"}>
//                         <Login/>
//                     </Box>
//                     <Box className={"button_login_container_item_title"}>
//                         Войти
//                     </Box>
//                 </Button>
//             </Box>
//         </Box>
//     )
// }

export const ButtonAdd = ({onClick}) => {

    return (
        <button className={"button"} onClick={onClick}>
            <div className={"button_icon"}>
                <Add sx={{fontSize: "18px"}}/>
            </div>
            <div className={"button_title"}>
                Добавить
            </div>
        </button>
    )
}

export const ButtonExport = ({onClick}) => {

    return (
        <button className={"button"} onClick={onClick}>
            <div className={"button_icon"}>
                <FileDownload sx={{fontSize: "18px"}}/>
            </div>
            <div className={"button_title"}>
                Экспорт
            </div>
        </button>
    )
}

export const ButtonSend = ({onClick}) => {

    return (
        <button className={"button"} onClick={onClick}>
            <div className={"button_icon"}>
                <Send sx={{fontSize: "15px"}}/>
            </div>
            <div className={"button_title"}>
                Отправить
            </div>
        </button>
    )
}

export const ButtonGateway = ({onClick}) => {

    return (
        <button className={"button"} onClick={onClick}>
            <div className={"button_icon"}>
                <Login sx={{fontSize: "15px"}}/>
            </div>
            <div className={"button_title"}>
                Войти
            </div>
        </button>
    )
}

export const ButtonPrint = ({onClick}) => {

    return (
        <button className={"button_circle"} onClick={onClick}>
            <div className={"button_circle_icon"}>
                <Print sx={{fontSize: "23px"}}/>
            </div>
        </button>
    )
}

export const ButtonUpdate = ({onClick, disabled = false}) => {

    return (
        <button className={"button_circle"} onClick={onClick} disabled={disabled}>
            <div className={"button_circle_icon"}>
                <Update sx={{fontSize: "23px"}}/>
            </div>
        </button>
    )
}

export const ButtonReset = ({onClick}) => {

    return (
        <button className={"button_mini"} onClick={onClick}>
            <div className={"button_mini_title"}>
                Сбросить
            </div>
        </button>
    )
}


